import { render, staticRenderFns } from "./CartasContent.vue?vue&type=template&id=0a2e0406&"
import script from "./CartasContent.vue?vue&type=script&lang=js&"
export * from "./CartasContent.vue?vue&type=script&lang=js&"
import style0 from "./CartasContent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports